import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BannerDTO } from '../interfaces/banner-management/banner-dto.interface';
import { BannerCategoryDTO } from '../interfaces/banner-management/banner-category-dto.interface';
import { IAutoDirectSetting } from '../interfaces/auto-direct-settings';
import { BaseDataService } from './base.data.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IBannerFilter } from '../interfaces/banner-management/banner-filter.interface';

@Injectable({ providedIn: 'root' })
export class BannerManagementService extends BaseDataService {
  public url = '/api/banner-management';

  constructor(public http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getBanners(filterCommand: IBannerFilter): Promise<BannerDTO[]> {
    return this.http
      .get<BannerDTO[]>(`${this.url}`, {
        params: this.constructHttpParams(filterCommand),
      })
      .toPromise();
  }

  public deleteBanner(id: number): Promise<any> {
    return this.http.delete<any>(`${this.url}/${id}`).toPromise();
  }

  public saveBanner(dto: BannerDTO): Promise<BannerDTO> {
    return this.handleRequest<any>(
      this.http.post<BannerDTO>(this.url, dto),
      this.handlersFactory.getForCreate('Banner'),
    );
  }

  public patchBanner(id: number, patch: any) {
    return this.http.patch<BannerDTO>(`${this.url}/banner/${id}`, patch).toPromise();
  }

  public getBannerCategories(): Promise<BannerCategoryDTO[]> {
    return this.http.get<BannerCategoryDTO[]>(`${this.url}/categories`).toPromise();
  }
}
